export const numbers = {
    numeric: (value) => {
        const v = parseFloat(value);
        return !isNaN(v) && isFinite(v) ? v : value;
    },
};
export const format = {
    phoneNumber: (value, previousValue) => {
        const validChar = /[\d.()\- +]+$/;
        if (validChar.test(value)) {
            return value;
        }
        if (value === '') {
            return '';
        }
        return previousValue;
    },
};
export default {
    numbers,
    format,
};
//# sourceMappingURL=parsers.js.map